import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { isFeatureEnabled } from 'owa-feature-flags';
import store from '../store/store';

export default function shouldUse3SPeopleSuggestions(): boolean {
    // 3S currently doesn't support the explicit logon scenario, so fallback to using findPeople if this is explict logon
    const userConfiguration = getUserConfiguration();
    const isExplicitLogon =
        userConfiguration &&
        userConfiguration.SessionSettings &&
        userConfiguration.SessionSettings.IsExplicitLogon;

    // LinkedIn suggestions are only served through 3S
    const isAny3SFlightEnabled =
        isFeatureEnabled('rp-3SPeopleSuggestions') ||
        isFeatureEnabled('rp-linkedInPeopleSuggestions');

    return (
        !store.fallbackToFindPeople &&
        isAny3SFlightEnabled &&
        !isExplicitLogon &&
        userConfiguration.SessionSettings.IsSubstrateSearchServiceAvailable
    );
}
